import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppComponent from './app';
import setupAxiosInterceptors from './config/axios-interceptor';
import { loadIcons } from './config/icon-loader';
import initStore from './config/store';
import { registerLocale } from './config/translation';
import { clearAuthentication } from './shared/reducers/authentication';
import { noLog } from './shared/util/method-util';

process.env.NODE_ENV !== 'development' && noLog();
export const store = initStore();
registerLocale(store);

const actions = bindActionCreators({ clearAuthentication }, store.dispatch);
setupAxiosInterceptors(() => actions.clearAuthentication('login.error.unauthorized'));

loadIcons();

const rootEl = document.getElementById('root');

const render = Component =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <Provider store={store}>
      <Component />
    </Provider>
    ,
    rootEl
  );

render(AppComponent);
